import React, { Component, Fragment } from 'react';

import './Duties.css';

import ModernCalendar from '../../Home/Mobile/Calendar/Calendar';
import TimeSlider from './TimeSlider/TimeSlider';
import Suggest from '../../Reminder/Mobile/Suggest/Suggest';
import Alarm from './Alarm/Alarm';
import Repeat from './Repeat/Repeat';
import ColorRadio from './ColorRadio/ColorRadio';
import Note from './Note/Note';

import calendar from '../../../assets/icons/calendar.svg';
import clock from '../../../assets/icons/clock.svg';

export default class Duties extends Component {

  render() {
    const {
      defaultLocation,
      zoom,
      location,
      float,
      tag,
      title,
      orders,
      repeat,
      repeats,
      alarm,
      alarms,
      selectedDay,
      selectedAlarm,
      selectedColor,
      selectedRepeat,
      note,
      colors,
      openCalendar,
      setOpenCalendar,
      openEvents,
      openFloat,
      openRepeat,
      closeFloat,
      closeRepeat,
      setSelectedDay,
      setColor,
      fillTitle,
      setTag,
      deleteTag,
      handleChange,
      handleChangeZoom,
      closeAlarm,
      setOpenAlarm,
    } = this.props;
    return (
      <Fragment>
        <div className="mobile-duties d-flex flex-column">
          <div className="mobile-duties__header d-flex">
            <h1>وظایف</h1>
            <button className="btn">ذخیره</button>
          </div>
          <Suggest
            float={float}
            openFloat={openFloat}
            tag={tag}
            title={title}
            closeFloat={closeFloat}
            fillTitle={fillTitle}
            orders={orders}
            setTag={setTag}
            deleteTag={deleteTag}
            name={'وظیفه'} />
          <div className="mobile-duties__features flex-wrap d-flex">
            <div className="mobile-duties__features--item">
              <h2>تاریخ و زمان</h2>
              <div className="mobile-float-input d-flex">
                <img src={calendar} className="mic" />
                <div className="mobile-float-input__value" onClick={() => setOpenCalendar()}>
                  {selectedDay ? selectedDay : 'انتخاب'}
                </div>
              </div>
            </div>
            <Alarm
              closeAlarm={closeAlarm}
              openAlarm={setOpenAlarm}
              selectedAlarm={selectedAlarm}
              alarm={alarm}
              alarms={alarms}
            />
            <Repeat
              closeRepeat={closeRepeat}
              openRepeat={openRepeat}
              selectedRepeat={selectedRepeat}
              repeat={repeat}
              repeats={repeats}
            />
          </div>
          <ColorRadio colors={colors} setColor={setColor} />
          <Note />
        </div>
        {
          openCalendar ?
            <div className="mobile-duty-calendar">
              <div className="mobile-duty-calendar__top" onClick={() => setOpenCalendar()}></div>
              <div className="mobile-duty-calendar__bottom">
                <ModernCalendar selectedDay={selectedDay} setSelectedDay={setSelectedDay} />
                <div className="mobile-duty-time d-flex flex-column">
                  <div className="d-flex">
                    <img src={clock} className="ml-3" />
                    <h3>ساعت وظیفه را انتخاب نمایید</h3>
                  </div>
                  <TimeSlider />
                  <button className="mobile-duty-calendar__bottom--button" onClick={() => setOpenCalendar()}>ثبت</button>
                </div>
              </div>
            </div> : null
        }
      </Fragment>
    );
  }
}